// src/utils/errorHandler.js
export const createErrorHandler = (vm) => {
    // 错误码映射表（可扩展）
    const codeMap = {
      400: 'error.400',
      401: 'error.401',
      403: 'error.403',
      404: 'error.404',
      429: "error.429",
      500: 'error.500',
      100010: "error.100010",
      10100: "error.10100",
      10101: "error.10101",
      10102: "error.10102",
      10103: "error.10103",
      10104: "error.10104",
      10111: "error.10111",
      10112: "error.10112",
      10113: "error.10113",
      10114: "error.10114",
      10115: "error.10115",
      10116: "error.10116",
      10120: "error.10120",
      10121: "error.10121",
      10122: "error.10122",
      10123: "error.10123",
      10141: "error.10141"
      // 添加更多错误码映射...
    };
  
    return {
      /**
       * 处理接口响应
       * @param {Object} response - 接口响应对象
       * @returns {Promise} 返回处理后的Promise
       */
      handleResponse(response) {
        if (response.code === 200) {
          return Promise.resolve(response);
        }
        if (response.code == 401 || response.code == 403) { 
          return Promise.reject(response);
        }
        const messageKey = codeMap[response.code] || 'error.default';
        vm.$message({
          message: vm.$t(messageKey),
          type: 'error'
        });
        return Promise.reject(response);
      }
    };
  };